import React, { useContext, useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as yup from "yup";
import { Grid } from "@mui/material";
import { Form } from "react-final-form";
import Stack from "@mui/material/Stack";
import FormControlLabel from "@mui/material/FormControlLabel";
import UiSwitch from "../../../_uiComponents/common/form/UiSwitch";
import UiInput from "../../../_uiComponents/UiInput";
import UiSelect from "../../../_uiComponents/common/form/UiSelect";
import MultiSelect from "../../../_uiComponents/common/form/MultiSelect";
import { UiButton } from "../../../_uiComponents/common/form/UiButton";
import Validator from "../../../../_helpers/validate.schema";
import { FORM_TYPE_EDIT, FORM_TYPE_ADD } from "../../../../_helpers/constants";
import {
     factTableValueAddRequest,
     factTableValueUpdateRequest,
     factTableGetAllSchemeAttributeRequest,
     factTableGetAllSchemaTypeRequest,
     lookupTableListRequest,
} from "../../../../_redux/_actions";
import { Context } from "../../../../_context/Store";
import { contextApiActions } from "../../../../_redux/_constants";

const validateSchema = () =>
     yup.object().shape({
          name: yup.string().required("Name is required."),
          schemaTypeId: yup.string().required("Type is required."),
     });

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export default function FactTableAddRowForm(props) {
     const actionDispatch = useDispatch();

     const [initialValues, setInitialValues] = useState({});
     const [fieldType, setFieldType] = useState("");

     const { tableValueDetails, schemeAttribute, schemaType, lookupTableList } =
          useSelector((state) => {
               return {
                    tableValueDetails: state.factTable.tableValueDetails,
                    schemeAttribute: state.factTable.schemeAttribute,
                    schemaType: state.factTable.schemaType,
                    lookupTableList: state.lookupTable.list.data,
               };
          });

     const [state, dispatch] = useContext(Context);

     useEffect(() => {
          if (props.type === FORM_TYPE_EDIT) {
               const value = {
                    name: tableValueDetails.name,
                    schemaTypeId: tableValueDetails.typeId,
                    schemaAttributeId: tableValueDetails.attribute
                         ? tableValueDetails.attribute.id
                         : null,
                    lookupTableId: tableValueDetails.lookupTableId,
                    identifier: tableValueDetails.identifier,
                    required: tableValueDetails.required,
                    filterable: tableValueDetails.filterable,
               };

               setInitialValues({ ...value });

               if (tableValueDetails.typeId) {
                    getAttributes(tableValueDetails.typeId);
               }

               if (tableValueDetails.type == "Lookup Table") {
                    setFieldType("LOOKUP_TABLE");
               }
          }

          if (props.type === FORM_TYPE_ADD) {
               setInitialValues({});
          }
     }, [tableValueDetails, schemeAttribute, lookupTableList]);

     useEffect(() => {
        //  actionDispatch(factTableGetAllSchemeAttributeRequest());
          actionDispatch(factTableGetAllSchemaTypeRequest());
          actionDispatch(
               lookupTableListRequest({
                    page: 1,
                    pageSize: 100,
               }),
          );
     }, []);

     const getAttributes = (typeId) => {
          actionDispatch(factTableGetAllSchemeAttributeRequest({ typeId }));
     };

     const closeFormModal = () => {
          dispatch({
               type: contextApiActions.UI_MODAL_TOGGEL,
               payload: {
                    show: false,
               },
          });
     };

     const submit = async (values) => {
          let identifier = false;
          let required = false;
          let filterable = false;

          if (values.required) {
               required = true;
          }

          if (values.identifier) {
               identifier = true;
          }

          if(values.filterable){
               filterable = true;
          }

          if (props.type === FORM_TYPE_EDIT) {
               actionDispatch(
                    factTableValueUpdateRequest({
                         id: tableValueDetails.id,
                         name: values.name,
                         factTableId: props.tableId,
                         schemaTypeId: values.schemaTypeId,
                         schemaAttributeId: values.schemaAttributeId,
                         lookupTableId: values.lookupTableId,
                         required: required,
                         identifier: identifier,
                         filterable: filterable,
                         closeFormModal,
                    }),
               );
          } else {
               actionDispatch(
                    factTableValueAddRequest({
                         name: values.name,
                         factTableId: props.tableId,
                         schemaTypeId: values.schemaTypeId,
                         schemaAttributeId: values.schemaAttributeId,
                         lookupTableId: values.lookupTableId,
                         required: required,
                         filterable:filterable,
                         identifier: identifier,
                         closeFormModal,
                    }),
               );
          }
     };

     return (
          <Form
               onSubmit={submit}
               validate={onValidate}
               initialValues={initialValues}
               render={({ form, handleSubmit, values }) => {
                    return (
                         <form onSubmit={validateSchema}>
                              <>
                                   <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                             mt: 1,
                                        }}
                                   >
                                        <Grid
                                             container
                                             spacing={2}
                                             sx={{ mt: 1 }}
                                        >
                                             <Grid item xs={12} lg={6}>
                                                  <UiInput
                                                       type="text"
                                                       label="Field Name"
                                                       name="name"
                                                  />
                                             </Grid>
                                             <Grid item xs={12} lg={6}>
                                                  <UiSelect
                                                       id="fact-table-add-value-type-field-id"
                                                       label="Field Type"
                                                       name="schemaTypeId"
                                                       onChange={(value) => {
                                                            const typeObj =
                                                                 schemaType.find(
                                                                      (obj) =>
                                                                           obj.id ===
                                                                           value,
                                                                 );

                                                            setFieldType(
                                                                 typeObj.code,
                                                            );

                                                            // getAttributes(
                                                            //      value,
                                                            // );

                                                            form.change(
                                                                 "schemaAttributeId",
                                                                 "",
                                                            );
                                                       }}
                                                       options={schemaType.map(
                                                            (type) => {
                                                                 return {
                                                                      value: type.id,
                                                                      label: type.name,
                                                                 };
                                                            },
                                                       )}
                                                  />
                                             </Grid>

                                             {fieldType == "LOOKUP_TABLE" && (
                                                  <Grid item xs={12} lg={6}>
                                                       <UiSelect
                                                            id="fact-table-add-value-lookup-table-id-field"
                                                            label="Lookup table"
                                                            name="lookupTableId"
                                                            options={lookupTableList.map(
                                                                 (
                                                                      lookupTable,
                                                                 ) => {
                                                                      return {
                                                                           value: lookupTable.id,
                                                                           label: lookupTable.name,
                                                                      };
                                                                 },
                                                            )}
                                                       />
                                                  </Grid>
                                             )}
                                             {/* {schemeAttribute.length != 0 && (
                                                  <Grid item xs={12} lg={6}>
                                                       <UiSelect
                                                            id="fact-table-add-value-fact-table-attribute-field"
                                                            label="Attribute"
                                                            name="schemaAttributeId"
                                                            options={schemeAttribute.map(
                                                                 (type) => {
                                                                      return {
                                                                           value: type.id,
                                                                           label: type.name,
                                                                      };
                                                                 },
                                                            )}
                                                       />
                                                  </Grid>
                                             )} */}
                                             <Grid item xs={12} lg={2}>
                                                  <FormControlLabel
                                                       control={
                                                            <UiSwitch
                                                                 name="identifier"
                                                                 checked={
                                                                      props.type ==
                                                                      FORM_TYPE_ADD
                                                                           ? false
                                                                           : initialValues.identifier
                                                                 }
                                                                 onClick={(event) => console.log(event)}
                                                            />
                                                       }
                                                       label="Identity"
                                                       labelPlacement="top"
                                                       sx={{ mt: 0 }}
                                                       className="sba-switch-label"
                                                  />
                                             </Grid>
                                             <Grid item xs={12} lg={2}>
                                                  <FormControlLabel
                                                       control={
                                                            <UiSwitch
                                                                 name="required"
                                                                 checked={
                                                                      props.type ==
                                                                      FORM_TYPE_ADD
                                                                           ? false
                                                                           : initialValues.required
                                                                 }
                                                            />
                                                       }
                                                       label="Mandatory"
                                                       labelPlacement="top"
                                                       sx={{ mt: 0 }}
                                                       className="sba-switch-label"
                                                  />
                                             </Grid>
                                             <Grid item xs={12} lg={2}>
                                                  <FormControlLabel
                                                       control={
                                                            <UiSwitch
                                                                 name="filterable"
                                                                 checked={
                                                                      props.type ==
                                                                      FORM_TYPE_ADD
                                                                           ? false
                                                                           : initialValues.filterable
                                                                 }
                                                            />
                                                       }
                                                       label="Filterable"
                                                       labelPlacement="top"
                                                       sx={{ mt: 0 }}
                                                       className="sba-switch-label"
                                                  />
                                             </Grid>

                                             <Stack
                                                  spacing={2}
                                                  direction="row"
                                                  justifyContent="end"
                                                  sx={{ width: "100%", mt: 3 }}
                                             >
                                                  <UiButton
                                                       onClick={() => {
                                                            form.reset();
                                                            setInitialValues(
                                                                 {},
                                                            );
                                                       }}
                                                       name="Clear"
                                                       variant="outlined"
                                                       size="small"
                                                  />
                                                  <UiButton
                                                       name="Apply"
                                                       variant="contained"
                                                       size="small"
                                                       onClick={handleSubmit}
                                                  />
                                             </Stack>
                                        </Grid>
                                   </Grid>
                              </>
                         </form>
                    );
               }}
          />
     );
}
